// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__-RF2t","footer":"Footer_footer__2UljL"};